
import React from 'react';
import Layout from '@/components/Layout/Layout';
import SpeedConverter from '@/components/UnitConverter/SpeedConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const SpeedConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Speed Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of speed and velocity, from km/h to mph and more.
          </p>
        </div>
        
        <div className="mb-8">
          <SpeedConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Speed Converter</h2>
          <p>
            Our speed converter tool allows you to convert between various speed and velocity units 
            used in transportation, physics, and everyday life. Speed is the rate at which an object 
            moves and is typically measured as distance traveled per unit of time.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Speed Unit Conversions</h3>
          <p>
            Some of the most frequently used speed conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between kilometers per hour (km/h) and miles per hour (mph)</li>
            <li>Converting between meters per second (m/s) and kilometers per hour (km/h)</li>
            <li>Converting between knots and miles per hour (maritime and aviation)</li>
            <li>Converting between feet per second and meters per second (engineering)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Speed Converter</h3>
          <p>
            Using our speed converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the speed unit you're converting from</li>
            <li>Select the speed unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The speed converter supports a wide range of units, including meters per second (m/s), 
            kilometers per hour (km/h), miles per hour (mph), feet per second (ft/s), knots (nautical miles per hour), 
            Mach (speed of sound), and even the speed of light (c). Whether you're comparing vehicle speeds, 
            analyzing physics problems, or working with aviation or maritime speed measures, 
            our converter provides quick and accurate conversions.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default SpeedConverterPage;
